<app-modal-shell [config]="modalConfig">
  <div modal-content [formGroup]="form" class="area-dialog-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" autocomplete="off" />
      <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
      <mat-error *ngIf="form.get('name')?.hasError('minlength')">Debe tener al menos 3 caracteres</mat-error>
      <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Debe tener 150 caracteres o menos</mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="isActive">Activa</mat-checkbox>
  </div>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="saveArea()" [disabled]="form.invalid">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </ng-container>
</app-modal-shell>
